<template>
  <vue-autosuggest
    v-model="localValue"
    :suggestions="localSuggestions"
    :get-suggestion-value="getSuggestionValue"
    :limit="limit"
    :input-props="{
      id: 'autosuggest__input',
      class: 'form-control',
      placeholder,
    }"
    @selected="onSelected"
    @input="onInputChange"
  >
    <template v-if="errorMessage" slot="after-input"><span class="error-message">{{ errorMessage }}</span></template>
    <template slot-scope="{ suggestion }">
      <span
        class="suggestion-item-title"
      >
        {{ suggestion.item[title] }}
      </span><br>
      <small class="suggestion-item-text">{{ suggestion.item.text}}</small>
    </template>
  </vue-autosuggest>
</template>
  
  <script>
import { VueAutosuggest } from 'vue-autosuggest'

  export default {
    components: {
      VueAutosuggest,
    },
    props: {
      value: {
        type: String,
        default: null,
      },
      title: {
        type: String,
        default: 'title',
      },
      placeholder: {
        type: String,
        default: 'Search',
      },
      suggestions: {
        type: Array,
        default: () => [],
      },
      initialList: {
        type: Array,
        default: () => [],
      },
      limit: {
        type: Number,
        default: 5,
      },
      errorMessage: {
        type: String,
        default: null,
      },
    },
    data() {
      return {
        localValue: this.value,
        localSuggestions: this.initialList,
      }
    },
    watch: {
      value(value) {
        this.localValue = value
      },
      suggestions(suggestions) {
        if(!suggestions) return
        this.localSuggestions = suggestions
      },
    },
    methods: {
      onInputChange(text) {
        const data = this.initialList[0].data?.filter(suggestion => suggestion[this.title].toLowerCase().includes(text.toLowerCase()))
        const filteredSuggestions = [{
          data,
        }]
        this.$emit('input', text, filteredSuggestions)
      },
      getSuggestionValue(suggestion) {
        return suggestion.item[this.title]
      },
      onSelected(suggestion) {
        this.$emit('selected', suggestion.item)
        return suggestion.item[this.title]
      },
    },
  }
  </script>
  
  <style lang="scss">
  @import '../../scss/vue/libs/vue-autosuggest.scss';
  .suggestion-item-title {
    color: #6e6b7b;
    font-weight: 400 !important;
    text-transform: 'capitalize' !important;
  }
  .error-message {
    color: #f44336;
    font-size: 12px;
    font-weight: 400;
    line-height: 1.5;
    margin-bottom: 0;
    margin-top: 0;
    text-align: left;
  }
  </style>
  